const UPDATE_SCHOOL_INFO = '@@school/UPDATE_INFO';

const UPDATE_LOCATIONS = '@@school/UPDATE_LOCATIONS';
// const CLEAR_SEARCH = '@@search/CLEAR_SEARCH'

export default {
	UPDATE_SCHOOL_INFO,
	UPDATE_LOCATIONS
};
